import { render, staticRenderFns } from "./Decisions.vue?vue&type=template&id=78b4fa34&"
import script from "./Decisions.vue?vue&type=script&lang=js&"
export * from "./Decisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports